/* @flow */

import { compose } from 'ramda';
import * as React from 'react';

import RadioButton from './RadioButton';

type Props = {
  field: Object,
  data: Array<{ value: string, text: string }>,
};

const RadioButtonList = ({ field, data }: Props): React.Node => {
  const { name } = field;

  /*
   |----------------------------------------------------------------------------
   | Elements
   |---------------------------------------------------------------------------
   */

  return data.map(({ value, text }, index) => (
    <RadioButton name={name} text={text} value={value} key={index} />
  ));
};

export default compose(React.memo)(RadioButtonList);
